import { render, staticRenderFns } from "./back.vue?vue&type=template&id=0b8956d6&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"
import style0 from "./back.vue?vue&type=style&index=0&id=0b8956d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8956d6",
  null
  
)

export default component.exports